export enum WidgetType {
    DocumentListing = 1,
    NewsFeed = 2,
    AdvancedText = 3,
    ForumListing = 4,
    ForumFeed = 5,
    SiteMap = 6,
    FormListing = 7,
}
